<script lang="tsx">
import type { Moment } from 'moment'
import moment from 'moment'
import {
  defineComponent, ref, type PropType, type Ref,
} from 'vue'
import { useCalendar, type CalendarDay, useCalendarTemplate } from '../../composables'
import { TimePicker } from '../../../../lib'

export default defineComponent({
  props: {
    /**
     * Опция, запрещающая менять время
     */
    isFixedTime: {
      type: Boolean,
      default: false,
    },

    disablePastDates: {
      type: Boolean,
      default: false,
    },
    date: {
      type: Object as PropType<Moment | null>,
      required: true,
    },
    onSetDate: {
      type: Function as PropType<(date: Moment) => void>,
      required: true,
    },
  },
  setup(props) {
    const selectedDate: Ref<Moment> = ref(moment(props.date))
    const calendar = useCalendar(props.date || moment(), { disablePastDates: props.disablePastDates })
    const todayDate = moment().format('DD-MM-YYYY')

    const setDate = (date: Moment | null) => {
      selectedDate.value = moment(date)

      if (props.onSetDate) {
        props.onSetDate(moment(date))
      }
    }

    const formatDaysForCalendar = (day: CalendarDay) => {
      const cls = []

      if (day.faded || day.disabled) {
        cls.push('faded')
      }

      if (day.date.isSame(selectedDate.value, 'day')) {
        cls.push('selected')
      }

      if (todayDate === day.date.format('DD-MM-YYYY')) {
        cls.push('today')
      }

      return (
        <div onClick={() => { if (!day.disabled) setDate(day.date) }} class={`ark-ui-calendar-day ${cls.join(' ')}`}>
          <div class="ark-ui-calendar-day-border">
            { day.date.format('D') }
          </div>
        </div>
      )
    }

    return () => {
      const days: JSX.Element[] = calendar.days.value.map(formatDaysForCalendar)

      return (
        <div class="ark-ui-datetime-calendar">
          <div>
            { useCalendarTemplate(calendar, days) }
          </div>

          <div class="ark-ui-datetime-calendar-time">
            <span>Время</span>
            <TimePicker
              isDisabled={props.isFixedTime}
              modelValue={selectedDate.value.isValid() ? selectedDate.value : null}
              onValueChange={setDate}
            />
          </div>
        </div>
      )
    }
  },
})
</script>

<style lang="sass">
@import '../calendar'

.ark-ui-datetime-calendar
  &-time
    padding: 8px 24px
    background-color: #F6F6FA

    display: flex
    align-items: center
    justify-content: space-between

    .ark-ui-time-picker
      &-label
        margin-bottom: 0

      &-input
        border: none
        padding: 8px 16px
        background-color: #fff

      svg
        display: none
</style>
